import { render, staticRenderFns } from "./Ndbg.vue?vue&type=template&id=8681644e&scoped=true&"
import script from "./Ndbg.vue?vue&type=script&lang=js&"
export * from "./Ndbg.vue?vue&type=script&lang=js&"
import style0 from "./Ndbg.vue?vue&type=style&index=0&id=8681644e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8681644e",
  null
  
)

export default component.exports